import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";

export default function Setup() {
  const { login } = useAuth();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/setup", form);
      login(data.token, data.user);
      toast.success("Compte administrateur créé !");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <form
        onSubmit={submit}
        className="w-full max-w-md space-y-7 animate-in fade-in slide-in-from-bottom-4 duration-500"
      >
        <div className="space-y-2">
          <span className="grid place-items-center h-12 w-12 rounded-2xl bg-primary text-primary-foreground">
            <ShieldCheck className="h-6 w-6" />
          </span>
          <h1 className="font-heading text-3xl font-bold tracking-tight pt-2">
            Configuration initiale
          </h1>
          <p className="text-muted-foreground text-sm">
            Aucun usager n'existe encore. Créez le premier compte administrateur pour démarrer.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1.5">
            <Label htmlFor="fn">Prénom</Label>
            <Input id="fn" data-testid="setup-firstname-input" required value={form.first_name} onChange={set("first_name")} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="ln">Nom</Label>
            <Input id="ln" data-testid="setup-lastname-input" required value={form.last_name} onChange={set("last_name")} />
          </div>
          <div className="space-y-1.5 col-span-2">
            <Label htmlFor="em">Courriel</Label>
            <Input id="em" data-testid="setup-email-input" type="email" required value={form.email} onChange={set("email")} />
          </div>
          <div className="space-y-1.5 col-span-2">
            <Label htmlFor="pw">Mot de passe</Label>
            <Input id="pw" data-testid="setup-password-input" type="password" required value={form.password} onChange={set("password")} />
          </div>
        </div>

        <Button data-testid="setup-submit-btn" type="submit" disabled={loading} size="lg" className="w-full active:scale-95 transition-transform">
          {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
          Créer l'administrateur
        </Button>
      </form>
    </div>
  );
}
